/** biome-ignore-all lint/complexity/useSimpleNumberKeys: this rule would messup our color codes like 500_8 => 5008 */
import { alpha, type ThemeOptions } from '@mui/material';
import type { DeepPartial } from 'types/utils';

// Base color: #007c47, step up 8%, step down 11%
// Main green color for Giphar brand
const primary = {
  lighter: '#99E6C6', // 200
  light: '#33C491', // 400
  main: '#007c47', // 500
  dark: '#005731', // 600
  darker: '#00321C', // 700
};

// Success green (slightly lighter than primary)
const success = {
  lighter: '#B4DFC5',
  light: '#7BC699',
  main: '#48A86E',
  dark: '#26593B',
  darker: '#163221',
};

// Warning orange
const warning = {
  lighter: '#FCE6D1',
  light: '#F8BC84',
  main: '#F39237',
  dark: '#E4760E',
  darker: '#7A3F07',
};

// Grey scale - adjusted for better contrast
const grey = {
  100: '#F5F6F5',
  200: '#DFE1DE',
  300: '#BEC1BD',
  400: '#9DA19C',
  500: '#7C817B',
  600: '#5B615A',
  700: '#474B46',
  800: '#2E312D',
  900: '#1A1C19',
  500_8: alpha('#7C817B', 0.08),
  500_12: alpha('#7C817B', 0.12),
  500_16: alpha('#7C817B', 0.16),
  500_24: alpha('#7C817B', 0.24),
  500_32: alpha('#7C817B', 0.32),
  500_48: alpha('#7C817B', 0.48),
  500_56: alpha('#7C817B', 0.56),
  500_80: alpha('#7C817B', 0.8),
};

export const themeOptions: DeepPartial<ThemeOptions> = {
  palette: {
    primary,
    success,
    warning,
    grey,
    background: {
      default: '#FFFFFF',
    },
    text: {
      primary: grey[800],
      secondary: grey[600],
      disabled: grey[500],
    },
    action: {
      hover: alpha(primary.main, 0.12), // Dropdown menu hover background color
    },
    navBar: {
      menuActiveBg: primary.main,
      menuActiveText: '#FFFFFF',
      menuDefaultText: primary.main,
      menuHoverBg: alpha(primary.main, 0.08),
      menuHoverText: primary.dark,
      menuSecondaryText: grey[500],
      searchHoverBorder: primary.light,
    },
  },
};
